// import Vue from 'vue';
import Alert from '../components/Alert.vue';

// export default function(msg) {
//     const component = new Vue({ 
//         ...Alert,
//         propsData: { message: msg }
//     });
    
//     const appEl = document.getElementById('app');
//     const exists = document.getElementsByClassName('alert-container');
//     if(exists[0]) {
//         appEl.removeChild(exists[0]);
//     }
//     const alertEl = document.createElement('div');
//     alertEl.setAttribute('id', 'valert');
//     appEl.appendChild(alertEl);
//     component.$mount('#valert');
// }

export default {
    install: function (Vue) {
        Vue.prototype.$alert = function(msg) {
            const component = new Vue({ 
                ...Alert,
                propsData: { message: msg }
            });
            
            const appEl = document.getElementById('app');
            const exists = document.getElementsByClassName('alert-container');
            if(exists[0]) {
                appEl.removeChild(exists[0]);
            }
            const alertEl = document.createElement('div');
            alertEl.setAttribute('id', 'valert');
            appEl.appendChild(alertEl);
            component.$mount('#valert');
        }
    }
};
